// EditPersonnelDialog/index.js
import { connect } from 'react-redux';

import EditPersonnelDialog from '../../components/EditPersonnelDialog';
import {
  openEditPersonnelDialogDispatch,
  handlePersonnelInputChangeDispatch,
  submitPersonnelDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.personnel.newPersonnel.showEditPersonnelDialog,
    personnel: state.personnel.newPersonnel.item,
    isSaving: state.personnel.newPersonnel.isSaving,
    branches: state.branches.allBranches && state.branches.allBranches.items,
    sites: state.personnels.sites.items
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openCreatePersonnelDialog: (open) => {
      dispatch(openEditPersonnelDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handlePersonnelInputChangeDispatch(value, inputFieldName));
    },
    submitPersonnel: (personnel) => {
      const mode = submitMode.UPDATE;
      dispatch(submitPersonnelDispatch(personnel, mode));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPersonnelDialog);
